import { useState, createContext, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [sharedPreference, setSharedPreference] = useState({});
  const [currentUser, setCurrentUser] = useState(null);
  const [gameMode, setGameMode] = useState("Account");

  const setGameModeTrading = () => setGameMode("Trading A/C");

  const setGameModePremium = () => setGameMode("Premium A/C");

  const setGameModeFree = () => setGameMode("Demo A/C");

  const isPremiumMode = gameMode === "Premium A/C";

  const isTradingMode = gameMode === "Trading A/C";

  const isFreeMode = gameMode === "Demo A/C";

  const togglePremiumGameMode = () => {
    setGameModePremium();
    if (isPremiumMode || isTradingMode) {
      setGameMode("Account");
    }
  };
  const toggleFreeGameMode = () => {
    setGameModeFree();
    if (isFreeMode) {
      setGameMode("Account");
    }
  };

  const logout = () => {
    setLoggedIn(false);
    setGameMode("Account");
  };

  const getBalanceType = () => {
    if (isFreeMode) {
      return "DCR";
    } else if (isPremiumMode) {
      return "PCR";
    } else if (isTradingMode) {
      return "TCR";
    } else {
      return "CR";
    }
  };

  const values = {
    loggedIn,
    logout,
    setCurrentUser,
    currentUser,
    setLoggedIn,
    sharedPreference,
    setSharedPreference,
    setGameModeFree,
    setGameModePremium,
    setGameModeTrading,
    isFreeMode,
    isPremiumMode,
    isTradingMode,
    gameMode,
    getBalanceType,
    togglePremiumGameMode,
    toggleFreeGameMode,
  };

  return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
